<template>
  <div class="w-full max-lg:py-14 py-20 mt-4">
    <div
      class="relative w-full max-lg:w-[92%] h-[17.5rem] flex flex-col justify-center items-center max-w-[89rem] mx-auto overflow-hidden rounded-2xl"
    >
      <img
        class="w-full h-full max-lg:object-cover absolute -z-10"
        src="@/assets/img/introduce_banner.jpg"
      />
      <h1 class="text-center font-bold text-white mx-auto">
        총회교육개발원 소개
      </h1>
      <ul class="w-fit absolute bottom-0 flex mx-auto gap-5 overflow-auto">
        <li
          v-for="tab in tabs"
          :key="tab.key"
          @click="changeTab(tab.key)"
          :class="[
            'p-3 cursor-pointer transition-colors duration-200 shrink-0',
            introIdx === tab.key
              ? 'text-[var(--main-blue-light)] border-b-2 border-[var(--main-blue-light)]'
              : 'text-neutral-400 hover:text-neutral-200',
          ]"
        >
          <b class="text-xl">{{ tab.label }}</b>
        </li>
      </ul>
    </div>
  </div>

  <main class="max-w-[75rem] mx-auto mb-20">
    <!-- 총회교육개발원 이야기 -->
    <div class="w-full mx-auto max-lg:px-5" v-if="introIdx === '1'">
      <pre class="whitespace-pre-line pb-20 text-xl max-lg:text-base">
      대한예수교장로회총회는 한국교회의 성장과 함께 미래 세대를 세우는 신앙교육 사역을 꾸준히 이어왔습니다.
      총회교육개발원은 그 사역의 역사와 정신을 계승하며, 미래세대 교회 교육을 위해 설립된 기관입니다. 우리는 개혁주의 신학에 기초하여, 성경에 근거한 기독교 교육 콘텐츠를 연구·개발하고, 교회학교와 가정, 교회 현장의 교육을 실제적으로 지원하는 사명을 감당하고 있습니다.
      </pre>

      <h2 class="nanum-square font-bold text-left">역사와 연혁</h2>

      <ul class="intro_history_wr">
        <li></li>
        <li>
          <b class="text-xl max-lg:text-base">한국교회 교육의 기초</b>
          <div>
            <img
              src="/assets/image/intro_history1.png"
              alt="한국교회 교육의 기초"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              초기 한국교회는 미국에서 발간된 ‘세계통일공과’를 번역하여 사용했습니다.
1961년에는 기독교교육협회를 중심으로 ‘계단공과’가 발간되어 ‘세계통일공과’와 함께 교회학교 교육의 토대를 마련했습니다.
            </pre>
          </div>
        </li>
        <li>
          <b class="text-xl max-lg:text-base">교단 중심의 공과 체제 확립</b>
          <div>
            <img
              src="/assets/image/intro_history2.png"
              alt="교단 중심의 공과 체제 확립"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              1965년 충현교회(김창인 목사)는 자체적으로 ‘계단공과’를 제작하기 시작했고, 1967년에는 이 사역을 교단에 무상으로 위임했습니다.
이를 계기로 전국 교회가 동일한 공과를 사용하게 되었고, 교단 차원의 체계적인 교육 시스템이 정착되었습니다.
            </pre>
          </div>
        </li>
        <li>
          <b class="text-xl max-lg:text-base">「말씀 믿음 삶」 발간<br/>(1998)</b>
          <div>
            <img
              src="/assets/image/intro_history3.png"
              alt="교단 중심의 공과 체제 확립"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              1998년 11월에는 새로운 공과 시리즈 ‘말씀 믿음 삶’ 이 출간되었습니다.
이 교재는 연령별·부서별 구성으로, “말씀 → 믿음 → 삶”의 단계적 구조를 통해 학습자가 말씀을 배우고 믿음으로 반응하며 삶 속에서 실천하도록 돕는 체계를 갖추었습니다.
또한 매년 여름과 겨울마다 성경학교 교재를 꾸준히 개발하여 전국 교회학교의 교육 현장을 풍성하게 지원했습니다.
            </pre>
          </div>
        </li>
        <li>
          <b class="text-xl max-lg:text-base">「생명의 빛」 발간<br/>(2010)</b>
          <div>
            <img
              src="/assets/image/intro_history4.png"
              alt="교단 중심의 공과 체제 확립"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              2010년 12월에는 신공과 ‘생명의 빛’ 이 발간되었습니다.
‘생명의 빛’은 급변하는 사회와 교육 환경 속에서 교재 내용과 교수 방법을 새롭게 개혁한 교재로, 학습자 중심 교육과 온라인 보조 학습 시스템을 반영하여 교회교육의 새로운 방향을 제시했습니다.
            </pre>
          </div>
        </li>
        <li>
          <b class="text-xl max-lg:text-base">총회교육개발원 설립<br/>(2019)</b>
          <div>
            <img
              src="/assets/image/intro_history5.png"
              alt="교단 중심의 공과 체제 확립"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              2019년, 교회학교 교육 콘텐츠 개발과 정책 연구를 전담하기 위한 총회교육개발원이 독립 기관으로 새롭게 출범했습니다. 
이를 통해 교단의 교육은 한층 전문화되고 체계화되었으며, 다음 세대를 위한 신앙교육의 새로운 전기를 마련했습니다.
            </pre>
          </div>
          <li>
          <b class="text-xl max-lg:text-base">「하나 바이블」 발간<br/>(2021)</b>
          <div>
            <img
              src="/assets/image/intro_history6.png"
              alt="교단 중심의 공과 체제 확립"
            />
            <pre class="whitespace-pre-line pb-10 lg:pb-20 max-lg:text-sm">
              2021년, 총회교육개발원은 코로나 19가 급증하던 시기, 변환된 상황과 시대의 흐름에 맞춘 새로운 성경공부 교재 ‘하나 바이블’을 선보였습니다.
‘하나 바이블’은 4차 산업혁명 시대와 디지털 교육 환경을 고려한 온·오프라인 통합형 교육 콘텐츠로, 영유아부부터 청소년부까지 모든 부서가 동일한 본문과 주제를 다루어 세대 간 연계와 통합 학습을 가능하게 합니다.
또한 하나 바이블 앱을 통해 교회와 가정이 함께 참여하는 새로운 교육 생태계를 구축하였으며, 찬양·설교·교사교육·가정예배 등 교회학교 전체를 아우르는 통합 교육체계로 발전했습니다.
            </pre>
          </div>
        </li>
        </li>
        <li></li>
      </ul>

      <pre
        class="pretendard whitespace-pre-line pb-10 md:pb-20 text-xl max-lg:text-base mt-10"
      >
      총회교육개발원은 개혁주의 신학의 토대 위에 서서, 하나님의 말씀으로 미래 세대를 세우는 신앙교육의 사명을 감당하고 있습니다.
      성경적 세계관에 기초한 교육으로 선순환적 교육 생태계를 구축합니다. 교회학교와 가정을 잇는 교육 콘텐츠로 신앙의 현장을 연결합니다. 시대의 변화에 맞는 창의적 교육방식으로 복음의 본질을 효과적으로 전달합니다. 교단의 교육 철학과 정체성을 지키며, 한국교회 교육의 표준을 만들어갑니다.
      </pre>
    </div>

    <!-- 총회교육개발원 미션 -->
    <div class="w-full mx-auto max-lg:px-5" v-if="introIdx === '2'">
      <div class="w-full max-w-[49.25rem] flex gap-20 mx-auto mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          <p><b>B</b>ible-based Policy</p>
          <p class="text-sm mt-2">성경 기반 정책 개발</p>
        </div>
        <pre
          class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center"
        >
        총회교육 정책 개발
        성경에 근거한 개혁주의 교육 정책의 구심점이 됩니다.
        </pre>
      </div>
      <div class="w-full max-w-[49.25rem] flex gap-20 mx-auto mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          <p><b>U</b>niting Church, Home, and School</p>
          <p class="text-sm mt-2">교회-가정-학교의 연합</p>
        </div>
        <pre
          class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center"
        >
        선순환적 기독교교육 시스템
        교회, 가정, 학교를 연합하여 선순환 교육 시스템을 만듭니다.
        </pre>
      </div>
      <div class="w-full max-w-[49.25rem] flex gap-20 mx-auto mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          <p><b>I</b>ntegrated Smart Learning</p>
          <p class="text-sm mt-2">통합 스마트 러닝</p>
        </div>
        <pre
          class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center"
        >
        ALL라인 스마트 러닝
        인공지능 기반의 온-오프라인 통합 스마트 러닝을 지향합니다.
        </pre>
      </div>
      <div class="w-full max-w-[49.25rem] flex gap-20 mx-auto mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          <p><b>L</b>ife-long Discipleship</p>
          <p class="text-sm mt-2">삶으로 이어지는 제자도</p>
        </div>
        <pre
          class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center"
        >
        말씀-삶 지원 프로그램
        말씀이 삶 속에서 실천되는 전인격적인 제자 교육을 지원합니다.
        </pre>
      </div>
      <div class="w-full max-w-[49.25rem] flex gap-20 mx-auto mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          <p><b>D</b>eveloping the Next Generation</p>
          <p class="text-sm mt-2">미래 세대 양육</p>
        </div>
        <pre
          class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center"
        >
        미래 세대 신앙 전수
        부서와 세대를 연결하는 교육으로 미래 세대를 양육합니다.
        </pre>
      </div>
    </div>

    <!-- 총회교육개발원 사람들 -->
    <div class="w-fit mx-auto max-lg:px-5" v-if="introIdx === '3'">

      <!-- 이사회 -->
      <div
        class="flex gap-10 items-center mb-20 flex-col"
      >
        <div class="flex flex-col items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M36.6406 17.8721L29.5938 24.0221L31.7047 33.1783C31.8164 33.657 31.7845 34.1579 31.6131 34.6186C31.4416 35.0792 31.1381 35.4791 30.7406 35.7682C30.3431 36.0573 29.8692 36.2229 29.3782 36.2441C28.8871 36.2654 28.4007 36.1414 27.9797 35.8877L19.9938 31.0439L12.025 35.8877C11.604 36.1414 11.1176 36.2654 10.6265 36.2441C10.1355 36.2229 9.66156 36.0573 9.26406 35.7682C8.86656 35.4791 8.56311 35.0792 8.39164 34.6186C8.22017 34.1579 8.1883 33.657 8.3 33.1783L10.4078 24.0314L3.35938 17.8721C2.98658 17.5505 2.71701 17.1261 2.58447 16.652C2.45193 16.1778 2.46232 15.6751 2.61434 15.2069C2.76635 14.7387 3.05324 14.3257 3.439 14.0199C3.82477 13.714 4.29225 13.5289 4.78282 13.4877L14.0734 12.683L17.7 4.03299C17.8894 3.57911 18.2088 3.19141 18.6181 2.9187C19.0274 2.646 19.5082 2.50049 20 2.50049C20.4918 2.50049 20.9726 2.646 21.3819 2.9187C21.7912 3.19141 22.1106 3.57911 22.3 4.03299L25.9375 12.683L35.225 13.4877C35.7156 13.5289 36.1831 13.714 36.5688 14.0199C36.9546 14.3257 37.2415 14.7387 37.3935 15.2069C37.5455 15.6751 37.5559 16.1778 37.4234 16.652C37.2908 17.1261 37.0212 17.5505 36.6484 17.8721H36.6406Z"
              fill="#ea580c"
            />
          </svg>
          <h3
            class="min-w-[12.5rem] nanum-square font-bold text-white bg-orange-600 rounded-xl px-6 py-4 mt-4 text-center"
            style="word-spacing: 0.75rem"
          >
            이 사 회
          </h3>
        </div>

        <div
          class="flex flex-col gap-4 max-lg:pt-10 max-lg:text-center"
        >
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >이사장</b
            >
            <div class="text-gray-500">송태근 목사(삼일교회)</div>
          </div>
          <div class="md:flex max-md:items-center md:leading-none">
            <b
              class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24 shrink-0"
              >이사</b
            >
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 text-gray-500 break-keep">
              <span>고동훈 목사(성문교회)</span
              ><span>고문산 목사(강남교회)</span
              ><span>권순웅 목사(주다산교회)</span
              ><span>김성고 목사(높은산샘물교회)</span>
              <span>김재철 목사(장성교회)</span
              ><span>김종준 목사(꽃동산교회)</span
              ><span>김창현 목사(소풍교회)</span
              ><span>배만석 목사(사랑스러운교회)</span>
              <span>오원석 목사(신용산교회)</span
              ><span>옥성석 목사(충정교회)</span
              ><span>우상현 목사(종암제일교회)</span
              ><span>이양수 목사(대구성서교회)</span>
              <span>이정현 목사(청암교회)</span
              ><span>이지훈 목사(범어교회)</span
              ><span>이한석 목사(광주동산교회)</span
              ><span>장봉생 목사(서대문교회)</span>
              <span>홍문수 목사(신반포교회)</span
              ><span>홍승영 목사(장지교회)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 자문위원 -->
      <div
        class="flex gap-10 items-center my-20 flex-col"
      >
        <div class="flex flex-col items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <g clip-path="url(#clip0_136_707)">
              <path
                d="M6.66666 18.3335C7.09146 18.334 7.50005 18.4966 7.80894 18.7882C8.11784 19.0799 8.30372 19.4784 8.32861 19.9025C8.35351 20.3266 8.21554 20.7441 7.94289 21.0699C7.67024 21.3956 7.28349 21.605 6.86166 21.6552L6.66666 21.6668H4.99999C4.5752 21.6664 4.16661 21.5037 3.85771 21.2121C3.54882 20.9205 3.36294 20.5219 3.33804 20.0978C3.31315 19.6738 3.45112 19.2562 3.72377 18.9304C3.99642 18.6047 4.38317 18.3953 4.80499 18.3452L4.99999 18.3335H6.66666ZM20 3.3335C20.4082 3.33355 20.8022 3.48342 21.1073 3.75469C21.4123 4.02595 21.6072 4.39974 21.655 4.80516L21.6667 5.00016V6.66683C21.6662 7.09163 21.5035 7.50022 21.2119 7.80911C20.9203 8.118 20.5217 8.30389 20.0977 8.32878C19.6736 8.35368 19.256 8.2157 18.9303 7.94305C18.6045 7.6704 18.3952 7.28366 18.345 6.86183L18.3333 6.66683V5.00016C18.3333 4.55814 18.5089 4.13421 18.8215 3.82165C19.134 3.50909 19.558 3.3335 20 3.3335ZM35 18.3335C35.4248 18.334 35.8334 18.4966 36.1423 18.7882C36.4512 19.0799 36.6371 19.4784 36.6619 19.9025C36.6868 20.3266 36.5489 20.7441 36.2762 21.0699C36.0036 21.3956 35.6168 21.605 35.195 21.6552L35 21.6668H33.3333C32.9085 21.6664 32.4999 21.5037 32.191 21.2121C31.8822 20.9205 31.6963 20.5219 31.6714 20.0978C31.6465 19.6738 31.7845 19.2562 32.0571 18.9304C32.3298 18.6047 32.7165 18.3953 33.1383 18.3452L33.3333 18.3335H35ZM8.15499 8.15516C8.44198 7.8682 8.82382 7.69582 9.22886 7.67035C9.6339 7.64488 10.0343 7.76808 10.355 8.01683L10.5117 8.15516L11.6783 9.32183C11.9772 9.62176 12.1508 10.0242 12.1637 10.4475C12.1766 10.8707 12.028 11.283 11.7479 11.6006C11.4679 11.9182 11.0774 12.1173 10.6559 12.1575C10.2343 12.1976 9.81331 12.0758 9.47833 11.8168L9.32166 11.6785L8.15499 10.5118C7.84254 10.1993 7.66702 9.77544 7.66702 9.3335C7.66702 8.89156 7.84254 8.46771 8.15499 8.15516ZM29.4883 8.15516C29.7883 7.85625 30.1907 7.68271 30.614 7.66978C31.0372 7.65686 31.4495 7.80552 31.7671 8.08558C32.0847 8.36563 32.2838 8.75608 32.324 9.17762C32.3641 9.59916 32.2423 10.0202 31.9833 10.3552L31.845 10.5118L30.6783 11.6785C30.3784 11.9774 29.9759 12.151 29.5527 12.1639C29.1294 12.1768 28.7171 12.0281 28.3995 11.7481C28.0819 11.468 27.8828 11.0776 27.8427 10.656C27.8025 10.2345 27.9243 9.81348 28.1833 9.4785L28.3217 9.32183L29.4883 8.15516ZM23.3333 30.0002C23.7754 30.0002 24.1993 30.1758 24.5118 30.4883C24.8244 30.8009 25 31.2248 25 31.6668C25 32.9929 24.4732 34.2647 23.5355 35.2024C22.5978 36.14 21.3261 36.6668 20 36.6668C18.6739 36.6668 17.4021 36.14 16.4645 35.2024C15.5268 34.2647 15 32.9929 15 31.6668C15 31.2586 15.1499 30.8646 15.4212 30.5595C15.6925 30.2545 16.0662 30.0596 16.4717 30.0118L16.6667 30.0002H23.3333ZM20 10.0002C22.0988 10.0002 24.1444 10.6605 25.8471 11.8877C27.5498 13.1149 28.8231 14.8468 29.4868 16.8379C30.1505 18.829 30.1709 20.9785 29.5451 22.9818C28.9193 24.9852 27.6791 26.7409 26 28.0002C25.7703 28.1727 25.4999 28.2829 25.215 28.3202L25 28.3335H15C14.6394 28.3335 14.2885 28.2165 14 28.0002C12.3209 26.7409 11.0807 24.9852 10.4549 22.9818C9.82906 20.9785 9.84946 18.829 10.5132 16.8379C11.1769 14.8468 12.4502 13.1149 14.1529 11.8877C15.8555 10.6605 17.9012 10.0002 20 10.0002Z"
                fill="#f59e0b"
              />
            </g>
            <defs>
              <clipPath id="clip0_136_707">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <h3
            class="min-w-[12.5rem] nanum-square font-bold text-white bg-amber-500 rounded-xl px-6 py-4 mt-4 text-center"
            style="word-spacing: 0.75rem"
          >
            자 문 위 원
          </h3>
        </div>

        <div class="">
          <div class="max-w-[55rem] grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 text-gray-500 break-keep">
            <span>김대훈 목사(초량교회)</span><span>김한성 목사(성산교회)</span><span>김희수 목사(성광교회)</span><span>박재신 목사(양정교회)</span><span>심욱섭 목사(해운대제일교회)</span>
            <span>윤영민 목사(대한교회)</span><span>이관형 목사(내일교회)</span><span>이인호 목사(더사랑의교회)</span><span>정명호 목사(혜성교회)</span><span>정창수 목사(산들교회)</span>
            <span>조상용 목사(대전중부교회)</span><span>홍석기 목사(상리교회)</span>
          </div>
        </div>
      </div>

      <!-- 전문위원 -->
      <div
        class="flex gap-10 items-center my-20 flex-col"
      >
        <div class="flex flex-col items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <g clip-path="url(#clip0_136_713)">
              <path
                d="M4.68887 25.7777L2.57776 34.8888C2.50494 35.2219 2.50743 35.567 2.58507 35.899C2.66271 36.231 2.81352 36.5414 3.0265 36.8076C3.23948 37.0738 3.50924 37.2891 3.81607 37.4377C4.1229 37.5864 4.45906 37.6646 4.79999 37.6666C4.95884 37.6827 5.11891 37.6827 5.27776 37.6666L14.4444 35.5555L32.0444 18.0222L22.2222 8.22217L4.68887 25.7777Z"
                fill="#06b6d4"
              />
              <path
                d="M37.5778 9.24463L31.0222 2.68907C30.5912 2.26026 30.008 2.01953 29.4 2.01953C28.792 2.01953 28.2088 2.26026 27.7778 2.68907L24.1333 6.33352L33.9444 16.1446L37.5889 12.5002C37.8022 12.2858 37.9711 12.0315 38.086 11.7518C38.2009 11.4721 38.2595 11.1725 38.2584 10.8701C38.2574 10.5677 38.1967 10.2685 38.08 9.98959C37.9632 9.71067 37.7925 9.45752 37.5778 9.24463Z"
                fill="#06b6d4"
              />
            </g>
            <defs>
              <clipPath id="clip0_136_713">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <h3
            class="min-w-[12.5rem] nanum-square font-bold text-white bg-cyan-500 rounded-xl px-6 py-4 mt-4 text-center"
            style="word-spacing: 0.75rem"
          >
            교 수<br/>전 문 위 원
          </h3>
        </div>

        <div class="flex flex-col gap-4 max-lg:pt-10 max-lg:text-center">
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >구약학</b
            >
            <div class="max-w-[55rem] grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>김대웅</span><span>김희석</span><span>이희성</span
              ><span>황선우</span><span>황성일</span>
            </div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >신약학</b
            >
            <div class="max-w-[55rem] flex max-md:justify-center gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>강대훈</span><span>조호형</span><span>박윤만</span>
            </div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >교회사</b
            >
            <div class="max-w-[55rem] flex max-md:justify-center gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>김요섭</span><span>안인섭</span>
            </div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >조직신학</b
            >
            <div class="max-w-[55rem] flex max-md:justify-center gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>박재은</span><span>이상웅</span><span>정승원</span>
            </div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >실천신학</b
            >
            <div class="max-w-[55rem] flex max-md:justify-center gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>김대혁</span><span>김준</span><span>주종훈</span>
            </div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >기독교교육</b
            >
            <div class="max-w-[55rem] grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>김수환</span><span>양신혜</span><span>유은희</span><span>오경환</span><span>이종민</span><span>하재송</span><span>함영주</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 실무연구원 -->
      <div
        class="flex gap-10 items-center my-20 flex-col"
      >
        <div class="flex flex-col items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M32 0H8C5.8 0 4 1.8 4 4V36C4 38.2 5.8 40 8 40H32C34.2 40 36 38.2 36 36V4C36 1.8 34.2 0 32 0ZM8 4H18V20L13 17L8 20V4Z"
              fill="rgb(55 48 163)"
            />
          </svg>
          <h3
            class="min-w-[12.5rem] nanum-square font-bold text-white bg-indigo-800 rounded-xl px-6 py-4 mt-4 text-center"
            style="word-spacing: 0.75rem"
          >
            실 무<br />연 구 원
          </h3>
        </div>

        <div
          class="flex flex-col gap-4 max-lg:pt-10 max-lg:text-center"
        >
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >원장</b
            >
            <div class="text-gray-500">노영주</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >선임연구원</b
            >
            <div class="text-gray-500">한유완</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24"
              >연구원</b
            >
            <div class="max-w-[55rem] grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 text-gray-500 break-keep">
              <span>성초희</span><span>문성광</span><span>남기숙</span><span>배승리</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 보도자료 -->
    <div class="w-full mx-auto max-lg:px-5" v-if="introIdx === '4'">
      <ul class="border-t border-black divide-y">
        <li class="py-3 lg:py-5">
          <a href="https://www.kidok.com/news/articleView.html?idxno=209019" target="_blank" class="block w-fit hover:text-blue-700 hover:underline transition-colors">
            <h3 class="font-medium">총회 융합형 통합 교재 〈하나 바이블〉 새롭게 출시</h3>
          </a>
          <p class="my-1 truncate">교단 다음세대 교육을 위해 새롭게 제작되는 융합형 통합 교재 이 드디어 모습을 드러냈다. 총회 융합형 공과인 은 몇 년간의 기획과 준비과정을 거치고 현장의 시범 및 수정·보완 작업을 한 후 이제 12월이면 만나볼 수 있다. </p>
          <div class="divide-x divide-neutral-400 text-neutral-400">
            <span class="mr-2 inline-block leading-none">기독신문</span>
            <span class="pl-2 inline-block leading-none">2020-11-25</span>
          </div>          
        </li>
        <li class="py-3 lg:py-5">
          <a href="https://www.kmib.co.kr/article/view.asp?arcid=0018959455" target="_blank" class="block w-fit hover:text-blue-700 hover:underline transition-colors">
            <h3 class="font-medium">예장합동 교리 교육 집중한 ‘하나 바이블’ 출간</h3>
          </a>
          <p class="my-1 truncate">대한예수교장로회(예장) 합동(총회장 오정호 목사) 총회교육개발원(원장 송태근 목사)이 교회학교 교리 교육 교재인 ‘하나 바이블’을 펴내고 세 차례에 걸쳐 전국 콘퍼런스를 진행했다.</p>
          <div class="divide-x divide-neutral-400 text-neutral-400">
            <span class="mr-2 inline-block leading-none">국민일보</span>
            <span class="pl-2 inline-block leading-none">2023-12-11</span>
          </div>                   
        </li>
        <li class="py-3 lg:py-5">
          <a href="https://youtu.be/W8KT9jrYYwU?si=HkZ8BpsAU7zQiO0Z" target="_blank" class="block w-fit hover:text-blue-700 hover:underline transition-colors">
            <h3 class="font-medium">하나 바이블 5과정 1학기 성품교육 콘퍼런스</h3>
          </a>
          <p class="my-1 truncate">대한예수교장로회(합동) 총회가 '하나 바이블 5과정 1학기 성품편' 출간을 기념해 콘퍼런스를 열었습니다. ... 지역에서 열린 콘퍼런스는 찬양 율동 배우기, 총회교육개발원 노영주 원장의 하나 바이블 성품 교육 방향 소개,</p>
          <div class="divide-x divide-neutral-400 text-neutral-400">
            <span class="mr-2 inline-block leading-none">CTS 뉴스</span>
            <span class="pl-2 inline-block leading-none">2024-12-05</span>
          </div>                   
        </li>
      </ul>
    </div>

    <!-- Contact us -->
    <div class="w-full max-w-[40rem] mx-auto max-lg:px-5" v-if="introIdx === '5'">
      <div class="w-full overflow-hidden map_area">
        <div id="daumRoughmapContainer1762323892013" class="root_daum_roughmap root_daum_roughmap_landing"></div>
      </div>
      
      <div
        class="flex items-center gap-2 mt-4 p-3"
      >
        <svg
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.156 13.544C8.899 12.01 12 8.876 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 2.37122e-08 4.4087 0 6C0 8.876 3.1 12.01 4.844 13.544C5.16211 13.8279 5.5736 13.9849 6 13.9849C6.4264 13.9849 6.83789 13.8279 7.156 13.544ZM4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6Z"
            fill="black"
          />
        </svg>
        <p class="text-lg">
          (06177) 서울특별시 강남구 영동대로 330(대치동) 총회회관 6층
          총회교육개발원
        </p>
      </div>

      <div
        class="flex items-center gap-2 p-3"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33341 6.57301C4.61352 9.36007 6.88767 11.5691 9.71074 12.7677L10.1641 12.9697C10.6661 13.1932 11.2309 13.2324 11.759 13.0803C12.2871 12.9282 12.7445 12.5947 13.0507 12.1383L13.6434 11.2557C13.7362 11.1173 13.7737 10.9491 13.7486 10.7844C13.7236 10.6197 13.6378 10.4703 13.5081 10.3657L11.5001 8.74568C11.4301 8.6893 11.3495 8.64763 11.2631 8.62318C11.1767 8.59873 11.0862 8.592 10.9971 8.6034C10.908 8.61479 10.8221 8.64408 10.7446 8.68949C10.6671 8.73491 10.5996 8.79552 10.5461 8.86768L9.92474 9.70568C8.32981 8.91797 7.03883 7.62675 6.25141 6.03168L7.08874 5.41035C7.16091 5.35685 7.22152 5.28933 7.26693 5.21183C7.31235 5.13433 7.34163 5.04845 7.35302 4.95934C7.36442 4.87024 7.35769 4.77975 7.33324 4.69332C7.30879 4.60688 7.26712 4.52628 7.21074 4.45635L5.59074 2.44835C5.48614 2.31865 5.33676 2.23282 5.17203 2.20777C5.00731 2.18272 4.83917 2.22027 4.70074 2.31301L3.81208 2.90901C3.35301 3.21687 3.01814 3.67769 2.86711 4.20939C2.71608 4.74109 2.75872 5.30914 2.98741 5.81235L3.33341 6.57301Z" fill="black"/>
        </svg>
        <p class="text-lg">
          대표전화 02)559-5643
        </p>
      </div>

      <div
        class="flex items-baseline gap-2 p-3"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8332 11.1427C13.8323 11.1746 13.8292 11.2065 13.8238 11.238C13.8379 11.3104 13.8358 11.385 13.8176 11.4564C13.7995 11.5279 13.7657 11.5944 13.7188 11.6513C13.672 11.7082 13.6131 11.7541 13.5464 11.7855C13.4797 11.817 13.4069 11.8333 13.3332 11.8333H3.99984C3.8904 11.8333 3.78204 11.8549 3.68093 11.8968C3.57983 11.9386 3.48796 12 3.41058 12.0774C3.3332 12.1548 3.27182 12.2467 3.22994 12.3478C3.18806 12.4489 3.1665 12.5572 3.1665 12.6667C3.1665 12.7761 3.18806 12.8845 3.22994 12.9856C3.27182 13.0867 3.3332 13.1785 3.41058 13.2559C3.48796 13.3333 3.57983 13.3947 3.68093 13.4366C3.78204 13.4784 3.8904 13.5 3.99984 13.5H13.3332C13.4658 13.5 13.593 13.5527 13.6867 13.6464C13.7805 13.7402 13.8332 13.8674 13.8332 14C13.8332 14.1326 13.7805 14.2598 13.6867 14.3536C13.593 14.4473 13.4658 14.5 13.3332 14.5H3.99984C3.51361 14.5 3.04729 14.3068 2.70347 13.963C2.35966 13.6192 2.1665 13.1529 2.1665 12.6667V3.33333C2.1665 2.8471 2.35966 2.38079 2.70347 2.03697C3.04729 1.69315 3.51361 1.5 3.99984 1.5H12.9332C13.4305 1.5 13.8332 1.90267 13.8332 2.4V11.1427ZM5.99984 4.16667C5.86723 4.16667 5.74005 4.21935 5.64628 4.31311C5.55252 4.40688 5.49984 4.53406 5.49984 4.66667C5.49984 4.79928 5.55252 4.92645 5.64628 5.02022C5.74005 5.11399 5.86723 5.16667 5.99984 5.16667H9.99984C10.1324 5.16667 10.2596 5.11399 10.3534 5.02022C10.4472 4.92645 10.4998 4.79928 10.4998 4.66667C10.4998 4.53406 10.4472 4.40688 10.3534 4.31311C10.2596 4.21935 10.1324 4.16667 9.99984 4.16667H5.99984Z" fill="black"/>
        </svg>

        <p class="text-lg">
          교재 관련 문의
        </p>
        <div class="space-y-4">
          <p>하나 바이블·계절공과 영유아부 ― 02)559-5647</p>
          <p>하나 바이블·계절공과 유치부 ― 02)559-5649</p>
          <p>하나 바이블·계절공과 유년부 ― 02)559-5642</p>
          <p>하나 바이블·계절공과 초등부 ― 02)559-5648</p>
          <p>하나 바이블·계절공과 청소년부 ― 02)559-5646</p>
          <p>eduwind.org@gmail.com</p>
        </div>
      </div>
    </div>

    <img src="@/assets/img/logo_origin.png" class="mx-auto my-20" />
  </main>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const introIdx = ref(route.params.category);
const tabs = [
  { key: "1", label: "총회교육개발원 이야기" },
  { key: "2", label: "총회교육개발원 미션" },
  { key: "3", label: "총회교육개발원 사람들" },
  { key: "4", label: "보도자료" },
  { key: "5", label: "Contact Us" },
];

const changeTab = (key) => {
  // 선택한 탭으로 라우팅
  router.push(`/introduce/${key}`);
};

watch(
  () => route.params.category,
  (newCategory) => {
    introIdx.value = newCategory;
  }
);

// 외부 스크립트(다음 지도 Roughmap) 동적 로더
const ensureDaumRoughmapLoaded = () => {
  return new Promise((resolve, reject) => {
    // 이미 로드된 경우 바로 종료 (생성자 확인)
    if (window.daum?.roughmap?.Lander) {
      resolve();
      return;
    }

    // 중복 로딩 방지 및 onload 처리
    const existing = document.getElementById("daum-roughmap-loader");
    if (existing) {
      // 로딩 완료까지 폴링 (최대 5초)
      const startedAt = Date.now();
      const timer = setInterval(() => {
        if (window.daum?.roughmap?.Lander) {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - startedAt > 5000) {
          clearInterval(timer);
          reject(new Error("Daum roughmap load timeout"));
        }
      }, 50);
      return;
    }

    const script = document.createElement("script");
    script.id = "daum-roughmap-loader";
    script.charset = "UTF-8";
    script.src = "https://ssl.daumcdn.net/dmaps/map_js_init/roughmapLoader.js";
    script.onload = () => {
      // 스크립트 로드 후에도 생성자 준비까지 대기
      const startedAt = Date.now();
      const timer = setInterval(() => {
        if (window.daum?.roughmap?.Lander) {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - startedAt > 5000) {
          clearInterval(timer);
          reject(new Error("Daum roughmap constructor not ready"));
        }
      }, 50);
    };
    script.onerror = () => reject(new Error("Failed to load Daum roughmap"));
    document.head.appendChild(script);
  });
};

// 지도 렌더링 함수 (탭이 '5'일 때만 호출)
const renderDaumMap = async () => {
  if (introIdx.value !== "5") return;
  await nextTick();

  const containerId = "daumRoughmapContainer1762323892013";
  const container = document.getElementById(containerId);
  if (!container) return;

  // 재진입 시 중복 렌더링 방지를 위해 컨테이너 초기화
  container.innerHTML = "";

  await ensureDaumRoughmapLoaded();

  // 다음 Roughmap 렌더링
  // 참고: mapWidth/mapHeight는 컨테이너 스타일에 의해 반응형으로 조절 가능
  // 여기서는 기본 값을 유지
  // 한국어 주석: 외부 라이브러리 객체 접근
  // eslint-disable-next-line no-undef
  new window.daum.roughmap.Lander({
    timestamp: "1762323892013",
    key: "c2gykbafox7",
    mapWidth: "640",
    mapHeight: "360",
  }).render();
};

onMounted(() => {
  renderDaumMap();
});

watch(introIdx, async (val) => {
  if (val === "5") {
    await renderDaumMap();
  }
});
</script>

<style>
.grid-custom {
  grid-template-columns: 3rem 1fr;
  grid-template-rows: auto;
}

.root_daum_roughmap .section_address { 
  display: none !important;
}

.map_area {
  width: 100%;
  max-width: 640px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
